import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef } from "react";
import { customSvg } from "../constants/customSvg";

const CustomDropdown = ({
  heading,
  isOpen,
  toggleDropdown,
  color,
  text,
  svgType,
  onLinkClick
}) => {
  const bgColor = "color-mix(in srgb, " + color + " 5%, white)";
  const iconBackground = "color-mix(in srgb, " + color + " 10%, white)";

  const parts = text.split('link');
  const contentRef = useRef(null);

  useEffect(() => {
    for (let i = 1; i <= 1; i++) {
      const elements = document.getElementsByClassName(`class${i}`);
      for (let element of elements) {
        if (element) {
          element.style.fill = color;
        }
      }
    }
  }, []);

  return (
    <>
      <div
        className="hover:border-gray-500 shadow leading-tight focus:outline-none focus:shadow-outline"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "12px 16px",
          gap: isOpen ? "10px" : "0px",
          borderRadius: "4px",
          fontFamily: "Inter",
          border: "1px solid #EEE",
          background: isOpen ? bgColor : "#FFF",
          transition: "background 0.3s linear,gap 0.3s linear",
        }}
      >
        <button
          onClick={toggleDropdown}
          className="appearance-none flex items-center w-full"
          style={{
            gap: "12px",
          }}
        >
          <div
            className="flex items-center justify-center rounded-full"
            style={{
              background: iconBackground,
              height: "36px",
              width: "36px",
            }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: customSvg[svgType] }}
              className="flex w-[32px] h-[32px] justify-center items-center "
            />
          </div>
          <span>{heading}</span>
          <ChevronDownIcon
            className={`h-5 w-5 text-gray-400 ml-auto transform transition-transform`}
            style={{
              transitionDuration: "0.3s",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
        <div
          ref={contentRef}
          onClick={toggleDropdown}
          className="text-[12px] md:text-[14px]"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            cursor: "pointer",
            textAlign: "left",
            alignSelf: "stretch",
            maxHeight: isOpen ? "500px" : "0px",
            overflowY: "auto",
            transition: "max-height 0.3s linear",
          }}
        >
          {parts.map((part, index) => (
        <span key={index}>
          {part}
          {index < parts.length - 1 && (
            <button
            onClick={onLinkClick}
            style={{ color: 'blue', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
          >
            link
          </button>
          )}
        </span>
      ))}
        </div>
      </div>
    </>
  );
};

export default CustomDropdown;
